<div class="content-padding">
  <div class="content-wrapper">
    <div class="content-header row">
        <div class="content-header-left col-md-12 col-12 mb-2">
            <div class="row breadcrumbs-top">
                <div class="col-12">
                    <h2 class="content-header-title float-left mb-0 border-right">Account Information</h2>
                </div>
            </div>
        </div>
    </div>
    <div class="content-body">
        <!-- account setting page -->
        <section>
            <div class="row">
                <!-- left menu section -->
                <div class="col-md-3 mb-2 mb-md-0">
                    <ul ngbNav #navVertical="ngbNav" class="nav nav-pills flex-column nav-left">
                        <!-- general -->
                        <li ngbNavItem>
                            <a ngbNavLink>
                                <i data-feather="user" class="font-medium-3 mr-1"></i>
                                <span class="font-weight-bold">General</span>
                            </a>
                            <ng-template ngbNavContent>
                              <div class="col-md-12">
                                <div class="card">
                                  <div class="card-body">
                                    <div class="validate-form">
                                      <form [formGroup]="user_form" (ngSubmit)="submit()">
                                        <div class="row">
                                            <div class="col-12">
                                              <div class="media">
                                                  <a href="javascript:void(0);" class="mr-25">
                                                    <img
                                                      [src]="avatarImage"
                                                      class="rounded mr-50"
                                                      alt="profile image"
                                                      height="76"
                                                      width="80"
                                                    />
                                                  </a>
                                                  <!-- upload and reset button -->
                                                  <div class="media-body mt-75 ml-1">
                                                    <button (click)="file.click()" type="button" for="account-upload" class="btn btn-sm btn-primary mb-75 mr-75" rippleEffect>
                                                      Choose image
                                                    </button>
                                                    <input type="file" #file id="account-upload" hidden accept="image/*" (change)="uploadImage($event)"/>
                                                    <p>Recommended 300x300 JPG or PNG</p>
                                                  </div>
                                                  <!--/ upload and reset button -->
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="form-group">
                                                    <label for="account-e-mail">E-mail</label>
                                                    <input type="email" class="form-control" id="account-e-mail" name="email" placeholder="Email" formControlName="email" readonly />
                                                    <span *ngIf="user_form.get('email').invalid && user_form.get('email').touched" class="invalid-form">
                                                      <small class="form-text text-danger" *ngIf="user_form.get('email').errors.email">email must be valid!</small>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-6">
                                                <div class="form-group">
                                                    <label for="first-name">Full name</label>
                                                    <input type="text" class="form-control" id="first-name" name="fname" placeholder="Full Name" formControlName="fullName" />
                                                    <span *ngIf="user_form.get('fullName').invalid && user_form.get('fullName').touched" class="invalid-form">
                                                      <small class="form-text text-danger" *ngIf="user_form.get('fullName').errors.required">This
                                                        field is
                                                        required!</small>
                                                    </span>
                                                </div>
                                            </div>
  
                                            <div class="col-12 col-sm-6">
                                              <div class="form-group">
                                                  <label for="register-hearAboutUs" class="form-label">How did you hear about us?</label>
                                                  <select id="register-hearAboutUs" formControlName="hearAboutUs" class="form-control">
                                                    <option [value]="'Twitter'">Twitter</option>
                                                    <option [value]="'Reddit'">Reddit</option>
                                                    <option [value]="'Facebook'">Facebook</option>
                                                    <option [value]="'Friends'">Friends</option>
                                                    <option [value]="'Email from Alpha Trend'">Email from Alpha Trend</option>
                                                    <option [value]="'LinkedIn'">LinkedIn</option>
                                                    <option [value]="'Google search'">Google search</option>
                                                  </select>
                                                </div>
                                            </div>
                                          <div class="col-12 col-sm-6">
                                            <div class="form-group">
                                              <label for="register-defaultService" class="form-label">What is your preferred trading?</label>
                                              <select id="register-defaultService" tabindex="5"  formControlName="defaultProduct" class="form-control">
                                                <option [value]="'STOCK'">Stocks</option>
                                                <option [value]="'CRYPTO'">Crypto</option>
                                                <option [value]="'NFT'">Nft</option>
                                              </select>
                                            </div>
                                          </div>
  
                                          <div class="col-12 col-sm-6">
                                            <div class="form-group">
                                              <label for="register-isNewsletter" class="form-label">Do you wish to receive newsletters?</label>
                                              <select id="register-isNewsletter" formControlName="isNewsletter" class="form-control">
                                                <option [value]="true">Yes</option>
                                                <option [value]="false">No</option>
                                              </select>
                                            </div>
                                          </div>
                                          
                                          <div class="col-12 col-sm-6">
                                            <div class="form-group">
                                                <label for="Wallet">Wallet Address</label>
                                                <input type="text" class="form-control" id="Wallet" name="walletAddress" placeholder="Wallet Address" formControlName="walletAddress" />
                                            </div>
                                          </div>
  
                                            <div class="col-12">
                                                <button type="submit" [disabled]="loading || user_form.invalid" class="btn btn-primary mt-2 mr-1">
                                                  <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                                                  Save changes
                                                </button>
                                                <button type="button" class="btn btn-outline-secondary mt-2" [routerLink]="'/'">Cancel</button>
                                            </div>
                                        </div>
                                      </form>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                        </li>
                        <!-- change password -->
                        <li ngbNavItem>
                            <a ngbNavLink>
                                <i data-feather="lock" class="font-medium-3 mr-1"></i>
                                <span class="font-weight-bold">Change Password</span>
                            </a>
                            <ng-template ngbNavContent>
                              <div class="col-md-12">
                                <div class="card">
                                  <div class="card-body">
                                    <div class="validate-form">
                                      <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error">
                                        <div class="alert-body">
                                            <p>{{ error }}</p>
                                        </div>
                                      </ngb-alert>
                                      <ngb-alert [type]="'success'" [dismissible]="false" *ngIf="message">
                                        <div class="alert-body">
                                            <p>{{ message }}</p>
                                        </div>
                                      </ngb-alert>
                                      <form [formGroup]="change_password" (ngSubmit)="changePassword()">
                                          <div class="row">
                                            <div class="col-12 col-md-6">
                                                <div class="form-group">
                                                    <label for="account-old-password">Old Password</label>
                                                    <div class="input-group form-password-toggle input-group-merge">
                                                        <input [type]="oldPassword ? 'text' : 'password'" formControlName="oldPassword" class="form-control" id="account-old-password" name="password" placeholder="Old Password" />
                                                        <div class="input-group-append">
                                                            <div class="input-group-text cursor-pointer">
                                                                <i class="feather font-small-4"
                                                                [ngClass]="{
                                                                    'icon-eye-off': oldPassword,
                                                                    'icon-eye': !oldPassword
                                                                }"
                                                                (click)="changePasswordToText('oldPassword')"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <span *ngIf="change_password.get('oldPassword').invalid && change_password.get('oldPassword').touched" class="invalid-form">
                                                        <small class="form-text text-danger" *ngIf="change_password.get('oldPassword').errors.required">This
                                                          field is
                                                          required!</small>
                                                    </span>
                                                </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                              <div class="col-12 col-sm-6">
                                              <div class="form-group">
                                                  <label for="account-new-password">New Password</label>
                                                  <div class="input-group form-password-toggle input-group-merge">
                                                      <input [type]="newPassword ? 'text' : 'password'" formControlName="newPassword" id="account-new-password" name="new-password" class="form-control" placeholder="New Password" />
                                                      <div class="input-group-append">
                                                          <div class="input-group-text cursor-pointer">
                                                              <i class="feather font-small-4"
                                                              [ngClass]="{
                                                                  'icon-eye-off': newPassword,
                                                                  'icon-eye': !newPassword
                                                              }"
                                                              (click)="changePasswordToText('newPassword')"></i>
                                                          </div>
                                                      </div>
                                                  </div>
                                                  <span *ngIf="change_password.get('newPassword').invalid && change_password.get('newPassword').touched" class="invalid-form">
                                                      <small class="form-text text-danger" *ngIf="change_password.get('newPassword').errors.required">This
                                                        field is
                                                        required!</small>
                                                  </span>
                                              </div>
                                              </div>
                                              <div class="col-12 col-sm-6">
                                                  <div class="form-group">
                                                      <label for="account-retype-new-password">Retype New Password</label>
                                                      <div class="input-group form-password-toggle input-group-merge">
                                                          <input [type]="confirmPassword ? 'text' : 'password'" formControlName="confirmPassword" class="form-control" id="account-retype-new-password" name="confirm-new-password" placeholder="New Password" />
                                                          <div class="input-group-append">
                                                              <div class="input-group-text cursor-pointer">
                                                                  <i class="feather font-small-4"
                                                                  [ngClass]="{
                                                                      'icon-eye-off': confirmPassword,
                                                                      'icon-eye': !confirmPassword
                                                                  }"
                                                                  (click)="changePasswordToText('confirmPassword')"></i>
                                                              </div>
                                                          </div>
                                                      </div>
                                                      <span *ngIf="change_password.get('confirmPassword').invalid && change_password.get('confirmPassword').touched" class="invalid-form">
                                                          <small class="form-text text-danger" *ngIf="change_password.get('confirmPassword').errors.required">This
                                                            field is
                                                            required!</small>
                                                      </span>
                                                      <span *ngIf="change_password.errors?.passwordNotMatch && change_password.get('confirmPassword').touched" class="invalid-form">
                                                          <small class="form-text text-danger" *ngIf="change_password.errors?.passwordNotMatch">New Password and Confirm Password does not match </small>
                                                      </span>
                                                  </div>
                                              </div>
                                              <div class="col-12">
                                                  <button type="submit" class="btn btn-primary mr-1 mt-1" >Save changes</button>
                                                  <button type="reset" class="btn btn-outline-secondary mt-1" [routerLink]="'/'">Cancel</button>
                                              </div>
                                          </div>
                                      </form>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                        </li>
                    </ul>
                </div>
                <!--/ left menu section -->
                <!-- right content section -->
                <div class="col-md-9">
                  <div [ngbNavOutlet]="navVertical" class="p-0 col-12"></div>
                </div>
            </div>
        </section>
        <!-- / account setting page -->
      <app-toast-container2 aria-live="polite" aria-atomic="true"></app-toast-container2>
    </div>
  </div>
</div>
  